import { FETCH_AUTHORIZED_ADMIN_EMAIL_DOMAINS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_AUTHORIZED_ADMIN_EMAIL_DOMAINS:
      return action.payload
    default:
      return state
  }
}
